module.exports = __webpack_public_path__ + "static/img/首页方案2.bfca4fde.png";